const categories = require('../utils/categories');
const ItemBuilder = require('./item.builder');

class FactoryDispatcher {
    constructor(cart) {
        this.cart = cart;
    }

    get insurance() {
        return new ItemBuilder(this.cart, categories.INSURANCE);
    }

    get serviceOption() {
        return new ItemBuilder(this.cart, categories.SERVICE_OPTION);
    }

    get fareRule() {
        return new ItemBuilder(this.cart, categories.FARE_RULE);
    }

    get bag() {
        return new ItemBuilder(this.cart, categories.BAGGAGE);
    }

    get seat() {
        return new ItemBuilder(this.cart, categories.SEATS);
    }

    get boardingOption() {
        return new ItemBuilder(this.cart, categories.BOARDING_OPTIONS);
    }

    get fastTrack() {
        return new ItemBuilder(this.cart, categories.FAST_TRACK);
    }
}

module.exports = (cart) => new FactoryDispatcher(cart);
